import React from 'react';

import { AssignmentDetails } from './assignmentType';

import {
  AssignmentMainTitle,
  AssignmentSubtitle,
  AssignmentTitleContainer,
} from './Assignment.styled';
import { getAssignmentSubtitle } from './utils/getAssignmentSubtitle';

export const AssignmenTitle = ({
  assignmentDetails,
}: {
  assignmentDetails: AssignmentDetails;
}) => {
  const isManualAssignment = assignmentDetails.provider === 'manual';
  const { startDate, endDate, closedAt, extensionTitle, title } =
    assignmentDetails;

  const dateSubtitle = getAssignmentSubtitle({
    startDate,
    endDate,
    closedAt,
    extensionTitle,
  });

  const subtitle = isManualAssignment ? 'Manual Assignment' : dateSubtitle;

  return (
    <AssignmentTitleContainer>
      <AssignmentMainTitle>{title}</AssignmentMainTitle>
      <AssignmentSubtitle>{subtitle}</AssignmentSubtitle>
    </AssignmentTitleContainer>
  );
};
